import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'js/components/lightbox';
import {runInAction} from 'mobx';
import {Provider, observer, inject} from 'mobx-react';
import LoadingSpinner from 'js/components/loading_spinner/index';
import ErrorBubble from 'js/components/error_bubble';
import {ManualDistributionStore} from './state';
import ManualDistributionPanel from './manual_distribution_panel';
import ManualInfeedDistributionContainer from './manual_infeed_distribution_container';
import ManualStoryDistributionContainer from './manual_story_distribution_container';

@inject(({campaignMetadataStore, postStateMachineStore}) => ({
    ...campaignMetadataStore,
    ...postStateMachineStore
}))
@observer
export default class ManualDistributionModal extends Component {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        onToggleShown: PropTypes.func.isRequired,
        contentMetadataId: PropTypes.number.isRequired,
        socialUserId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
    };

    constructor(props) {
        super(props);

        this.distributionStore = new ManualDistributionStore({
            /** Only allow choosing the view if non-instagram */
            // view:
            //     window.sn.campaign.type === 'instagram'
            //         ? null
            //         : ManualDistributionStore.viewOptions.IN_FEED
            view: ManualDistributionStore.viewOptions.IN_FEED
        });
    }

    componentDidMount() {
        if (this.props.show) {
            this.fetchDistributionForContent();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && !prevProps.show) {
            this.fetchDistributionForContent();
        }
    }

    /**
     * @param {(Event | undefined)} e
     * @memberof ManualDistributionModal
     */
    fetchDistributionForContent = (e) => {
        if (e) {
            e.preventDefault();
        }

        return this.distributionStore.fetchDistribution({
            content_metadata_id: parseInt(this.props.contentMetadataId, 10)
        });
    };

    onCloseModal = () => {
        const {onToggleShown} = this.props;

        onToggleShown();

        runInAction(() => {
            // this.distributionStore.view =
            //     window.sn.campaign.type === 'instagram'
            //         ? null
            //         : ManualDistributionStore.viewOptions.IN_FEED;

            this.distributionStore.view = ManualDistributionStore.viewOptions.IN_FEED;
        });
    };

    setView = (e, view) => {
        if (e) {
            e.preventDefault();
        }

        runInAction(() => {
            this.distributionStore.view = view;
        });
    };

    render() {
        const {show} = this.props;

        if (!show) {
            return <div />;
        }

        if (this.distributionStore.fetchError) {
            return (
                <Lightbox onClose={this.onCloseModal} className="manual-distribution-lightbox">
                    <div className="manual_distribution__panel-wrapper">
                        <ManualDistributionPanel
                            actions={
                                <button
                                    className="btn btn-danger"
                                    onClick={this.fetchDistributionForContent}
                                >
                                    Reload
                                </button>
                            }
                        >
                            <div className="layout-row--center layout-center">
                                <ErrorBubble message="Something went wrong while fetching information about this content." />
                            </div>
                        </ManualDistributionPanel>
                    </div>
                </Lightbox>
            );
        }

        if (!this.distributionStore.didFetchDistribution) {
            return (
                <Lightbox onClose={this.onCloseModal} className="manual-distribution-lightbox">
                    <div className="manual_distribution__panel-wrapper">
                        <div className="layout-row--center layout-center">
                            <LoadingSpinner additionalClasses="fa-5x" />
                        </div>
                    </div>
                </Lightbox>
            );
        }

        if (this.distributionStore.view) {
            return (
                <Provider
                    contentMetadataId={this.props.contentMetadataId}
                    socialUserId={this.props.socialUserId}
                    setView={this.setView}
                    distribution={this.distributionStore.distribution}
                >
                    <Lightbox onClose={this.onCloseModal} className="manual-distribution-lightbox">
                        <div className="manual_distribution__panel-wrapper">
                            {this.distributionStore.view ===
                            ManualDistributionStore.viewOptions.IN_FEED ? (
                                <ManualInfeedDistributionContainer
                                    onCloseModal={this.onCloseModal}
                                />
                            ) : (
                                <ManualStoryDistributionContainer
                                    onCloseModal={this.onCloseModal}
                                />
                            )}
                        </div>
                    </Lightbox>
                </Provider>
            );
        }

        return (
            <Provider distribution={this.distributionStore.distribution}>
                <Lightbox onClose={this.onCloseModal} className="manual-distribution-lightbox">
                    <div className="manual_distribution__panel-wrapper">
                        <ManualDistributionPanel
                            actions={
                                <div className="btn-group btn-group-vertical">
                                    <button
                                        onClick={(e) =>
                                            this.setView(
                                                e,
                                                ManualDistributionStore.viewOptions.IN_FEED
                                            )
                                        }
                                        className="btn btn-primary"
                                    >
                                        In-Feed
                                    </button>
                                    <button
                                        className="btn btn-info"
                                        onClick={(e) =>
                                            this.setView(
                                                e,
                                                ManualDistributionStore.viewOptions.STORY
                                            )
                                        }
                                    >
                                        Story
                                    </button>
                                </div>
                            }
                        >
                            <h2>Select A Distribution Type</h2>
                        </ManualDistributionPanel>
                    </div>
                </Lightbox>
            </Provider>
        );
    }
}



// WEBPACK FOOTER //
// ./components/manual_distribution_modal/index.js